var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 44,
    viewBox: "0 0 38 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6943 0C12.6278 0 7.67793 4.82342 7.44143 10.8348C7.43593 10.9833 7.41943 11.1263 7.41943 11.2748C7.41943 11.6158 7.44143 11.9458 7.46893 12.2813C7.91443 17.2587 11.5994 21.3177 16.4008 22.3131C17.1378 22.4671 17.9078 22.5496 18.6888 22.5496C19.4697 22.5496 20.2727 22.4616 21.0262 22.3021C24.9147 21.4772 28.0606 18.6392 29.3366 14.9378C29.7326 13.7883 29.9581 12.5563 29.9581 11.2748C29.9581 10.1088 29.7821 8.98685 29.4521 7.92537C28.0221 3.33845 23.7377 0 18.6888 0H18.6943Z",
    fill: "#0EDB6F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4343 43.6638C13.6343 43.4548 16.1202 43.2238 18.6942 43.2238C21.2682 43.2238 23.7541 43.4548 25.9541 43.6638C30.42 44.0817 33.9509 44.4062 35.7824 42.7343C36.8659 41.7553 37.3884 40.0173 37.3884 37.4269C37.3884 30.2935 33.368 24.0786 27.4721 20.9271C25.1511 23.0391 22.0711 24.3261 18.6942 24.3261C15.3173 24.3261 12.2373 23.0336 9.91634 20.9271C4.02043 24.0786 0 30.2935 0 37.4269C0 40.0173 0.522492 41.7553 1.60597 42.7343C3.43744 44.4062 6.96839 44.0762 11.4343 43.6638ZM22.4946 30.3375C22.8796 29.749 23.5341 29.397 24.2381 29.397H29.672C30.3815 29.397 31.036 29.749 31.421 30.3375C31.8005 30.926 31.8665 31.6575 31.5915 32.3009C30.7885 34.1434 28.968 35.3369 26.9551 35.3369C24.9421 35.3369 23.1271 34.1434 22.3241 32.3009C22.0436 31.6575 22.1096 30.926 22.4946 30.3375Z",
    fill: "#0EDB6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.ee906c6b158e565130360e2dff265056.svg";
export { ForwardRef as ReactComponent };